import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import { noop } from 'ui-components/default-props/noop';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';

import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import { printShipmentManifest } from '../../../../store/printing/print.actions';
import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';

export const ShipmentManifest = ({ selectedData, trackOnClick = noop, name = DocumentType.ShipmentManifest.documentNameTranslation }) => {
  const dispatch = useDispatch();
  const isDisabled = selectedData.length === 0;
  const fulfillmentPlanIds = useMemo(() => selectedData.map((f) => f.fulfillmentPlanId), [selectedData]);
  const printSettings = usePrintSettings(DocumentType.ShipmentManifest.printSettingKey);
  const onClick = useCallback(() => {
    dispatch(printShipmentManifest(fulfillmentPlanIds));
    trackOnClick();
  }, [dispatch, fulfillmentPlanIds, trackOnClick]);
  const onDownload = useCallback(() => {
    dispatch(downloadDocument(DocumentType.ShipmentManifest, fulfillmentPlanIds));
  }, [dispatch, fulfillmentPlanIds]);
  const onPrint = useCallback(() => {
    dispatch(printDocument(DocumentType.ShipmentManifest, fulfillmentPlanIds, printSettings));
  }, [dispatch, fulfillmentPlanIds, printSettings]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  return <PrintDocumentMenuItem defaultPrintSetting={defaultPrintSetting} disabled={isDisabled} name={name} onClick={onClick} />;
};

ShipmentManifest.propTypes = {
  selectedData: PropTypes.arrayOf(
    PropTypes.shape({
      fulfillmentPlanId: PropTypes.string.isRequired,
    }),
  ).isRequired,
  trackOnClick: PropTypes.func,
  name: MessageDescriptorPropType,
};
